<template>
  <div class="faq-background">
    <div class="faq-banner">
      <div class="faq-container">
        <div class="faq-banner-title">FAQ</div>
      </div>

      <img class="faq-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="faq-container">
      <div class="faq-content">

        <div v-for="faq in faqs">
          <div class="faq-question-text">Q：{{faq.question}}</div>
          <div class="faq-answer-background">
            <div class="faq-answer-text">A：{{faq.answer}}</div>
          </div>

        </div>

      </div>


    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "companyIntroduce",
    data() {
      return {
      }
    },
    computed: {
      ...mapState({
        faqs: state => state.Faq.faqs.info,
      })
    },
    created(){
      this.$store.dispatch('getFaq').then(res => {
      })
    },
  }
</script>

<style scoped>
  .faq-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .faq-background{
    margin-top: 70px;
  }
  .faq-banner{
    overflow:hidden;
  }
  .faq-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .faq-banner-img{
    min-width:100%;
    height:165px;
  }
  .faq-content{
    margin-top: 60px;
    margin-bottom: 100px;
  }
  .faq-question-text{
    font-size:16px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(73,145,201,1);
    line-height:25px;
  }
  .faq-answer-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .faq-answer-background{
    background:rgba(236,244,249,1);
    padding: 24px 16px;
    margin-top: 12px;
    margin-bottom: 32px;
  }
  @media screen and (max-width:482px) {
    .faq-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .faq-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .faq-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .faq-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .faq-container{
      max-width: 1068px;
    }
  }

</style>